module.exports = __webpack_public_path__ + "static/img/Tesi-Niu.d656b4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tesi-Niu.jpg
// module id = qCcu
// module chunks = 0